export const HISTORY_REQUEST = "HISTORY_REQUEST";
export const HISTORY_SUCCESS = "HISTORY_SUCCESS";
export const HISTORY_FAIL = "HISTORY_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";

export const SET_MESSAGE = "SET_MESSAGE";

// Add action types for updating job details
export const UPDATE_REQUEST = "UPDATE_REQUEST";
export const UPDATE_SUCCESS = "UPDATE_SUCCESS";
export const UPDATE_FAIL = "UPDATE_FAIL";
